// English copy for household (sprint 4). Same shape as food.nl.ts; the type enforces completeness.
export const foodEn = {
    nav: 'Food',
    title: 'Food',
    tabs: {
        shopping: 'Shopping',
        recipes: 'Recipes',
        menu: 'Meal plan',
        pantry: 'Pantry',
    },
    undo: 'Undo',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    remove: 'Remove',
    retry: 'Try again',
    errorLoad: 'Loading failed. Please try again.',
    errorSave: 'Saving failed. Please try again.',
    categories: {
        produce: 'Fruit and vegetables',
        bakery: 'Bread and breakfast',
        dairy: 'Dairy and eggs',
        meat: 'Meat and fish',
        pantry: 'Cupboard',
        drinks: 'Drinks',
        household: 'Household',
        other: 'Other',
    },
    units: {
        g: 'gram',
        kg: 'kilo',
        ml: 'ml',
        cl: 'cl',
        dl: 'dl',
        l: 'litre',
        el: 'tablespoon',
        tl: 'teaspoon',
        kop: 'cup',
        snuf: 'pinch',
        stuk: 'piece',
        teen: 'clove',
        blik: 'tin',
        pak: 'pack',
        zak: 'bag',
        bos: 'bunch',
        plak: 'slice',
        fles: 'bottle',
        doos: 'box',
        krop: 'head',
        pot: 'jar',
        takje: 'sprig',
        handje: 'handful',
        scheut: 'dash',
    },
    shopping: {
        addLabel: 'What do we need?',
        addPlaceholder: 'For example 2 packs of milk',
        add: 'Add',
        frequent: 'Often bought',
        inBasket: 'In your basket ({count})',
        clearChecked: 'Clear ticked',
        newList: 'List',
        newListTitle: 'New list',
        listName: 'List name',
        listNameHint: 'For example Market or Chemist',
        listsLabel: 'Shopping lists',
        renameList: 'Edit list',
        archiveList: 'Delete list',
        listMenu: 'More for this list',
        archiveAsk: 'Remove list {name}?',
        archiveHint: 'Everything on it goes too. You can undo it right away.',
        archivedList: 'List {name} deleted',
        lastList: 'The last list cannot be removed. Rename it instead.',
        emptyTitle: 'We have everything',
        emptyBody: 'Add something here; everyone sees it right away.',
        added: '{name} is on the list',
        merged: '{name}: now {amount}',
        removed: '{name} removed',
        cleared: 'Ticked items cleared',
        viaTablet: 'via the tablet',
        forRecipe: 'for {title}',
        editItem: 'Edit item',
        name: 'Name',
        amount: 'Amount',
        unit: 'Unit',
        noUnit: 'None',
        note: 'Note',
        icon: 'Pictogram',
        list: 'List',
        check: 'Tick off {name}',
        uncheck: 'Untick {name}',
        addedBy: 'Added by {name}',
    },
    recipes: {
        search: 'Search recipes',
        filterAll: 'All',
        filterOwn: 'Own',
        filterLibrary: 'Collection',
        add: 'Recipe',
        newTitle: 'New recipe',
        editTitle: 'Edit recipe',
        modeManual: 'Type it in',
        modeLink: 'From a link',
        link: 'Link to the recipe',
        linkHint: 'Works with recipe sites and with YouTube, TikTok and Instagram.',
        fetch: 'Fetch',
        fetching: 'Fetching recipe…',
        name: 'Recipe name',
        description: 'Short description',
        servings: 'Servings',
        minutes: 'Minutes',
        ingredients: 'Ingredients',
        ingredientsHint: 'One per line, for example 500 g minced meat',
        steps: 'Method',
        stepsHint: 'One step per line',
        minutesShort: '{n} min',
        people: '{n} ppl',
        video: 'Video',
        needsIngredients: 'Add the ingredients',
        noResults: 'No recipe found',
        noResultsBody: 'Try another word or add one yourself.',
        emptyTitle: 'No recipes yet',
        emptyBody: 'Add your first recipe, or fetch one from a link.',
        toMenu: 'Add to meal plan',
        toList: 'To shopping list',
        edit: 'Edit',
        photo: 'Add photo',
        changePhoto: 'Other photo',
        removePhoto: 'Remove photo',
        photoUploading: 'Uploading photo…',
        photoTooLarge: 'This photo is too large.',
        photoUnsupported: 'This file is not a photo we can use.',
        archive: 'Hide',
        archived: '{title} hidden',
        openVideo: 'Watch the video',
        openSource: 'Go to the website',
        back: 'All recipes',
        fromLibrary: 'From the collection',
        ingredientsEmpty: 'No ingredients yet.',
        stepsEmpty: 'No method yet.',
        toListTitle: 'To the shopping list',
        toListBody: 'Items already in the pantry or always at home are unticked.',
        toListDo: 'Put on the list',
        toListDone: '{count} on {list}',
        toListMerged: '{count} on {list}, {merged} merged',
        toListNothing: 'Everything is already on the list or at home.',
        staple: 'always at home',
        inPantry: 'at home',
        pickDayTitle: 'Add to meal plan',
        pickDay: 'Pick a day',
        planned: '{title} is planned for {day}',
        created: '{title} added',
        imported: '{title} fetched',
        importErrors: {
            no_recipe_found: 'We could not find a recipe on this page. Type it in yourself?',
            blocked_address: 'We cannot open this link.',
            invalid_url: 'Use a secure link (starting with https).',
            too_large: 'This page is too large to read.',
            timeout: 'The website did not respond in time. Please try again later.',
            fetch_failed: 'The website is not reachable right now.',
        },
        fillManually: 'Type it in',
    },
    menu: {
        week: 'Week {week}',
        range: '{from} – {to}',
        thisWeek: 'This week',
        prev: 'Previous week',
        next: 'Next week',
        allToList: 'All on the list',
        choose: 'Choose',
        chooseFor: 'Choose what we eat on {day}',
        dragHint: 'Drag a recipe onto a day',
        tapHint: 'Tap + Choose on a day',
        moreRecipes: 'More recipes ({count})',
        freeSection: 'Or something else, for example Eating out',
        freeSave: 'On the menu',
        pickRecipe: 'Pick a recipe',
        shelf: 'Recipes',
        removeMeal: 'Remove {title} from the plan',
        removed: '{title} removed from the plan',
        moved: 'Moved to {day}',
        freeText: 'Or type something else',
        freePlaceholder: 'For example Eating out',
        emptyTitle: 'Nothing planned yet',
        emptyBody: 'Drag a recipe onto a day.',
        today: 'today',
        nothingToList: 'There are no recipes planned this week yet.',
        servings: '{n} ppl',
    },
    pantry: {
        addLabel: 'What do we have at home?',
        addPlaceholder: 'For example 1 kg potatoes',
        add: 'Add',
        listLabel: 'In the pantry',
        removeItem: 'Remove {name} from the pantry',
        removed: '{name} removed from the pantry',
        suggestionsTitle: 'What can we make?',
        allInHouse: 'Everything at home',
        stillNeeded: 'Still needed: {items}',
        emptyTitle: 'The pantry is empty',
        emptyBody: 'Add what you have; we suggest what you can make.',
        noSuggestions: 'No recipe with enough at home yet.',
        staples: 'Salt, pepper, oil and water always count as at home.',
    },
    kiosk: {
        entry: 'Food',
        back: 'Back',
        tonight: 'Tonight we eat',
        nothingPlanned: 'Nothing planned yet',
        nothingPlannedBody: 'Mum or dad chooses in the app.',
        tomorrow: 'Tomorrow',
        add: 'Add',
        addTitle: 'What do we need?',
        close: 'Close',
        added: '{name} is on the list',
        oops: 'Oops',
        emptyTitle: 'We have everything',
        check: '{name}: in the basket?',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name}: back on the list',
        confirm: 'In the basket',
        shopping: 'Shopping',
        week: 'This week',
        inBasket: '{name} in the basket',
        more: 'More shopping',
        alreadyOn: '{name} was already on it',
        typeOwn: 'Type it',
        typeLabel: 'What do we need?',
        typePlaceholder: 'E.g. sprinkles',
        typeAdd: 'Add',
        closeTyping: 'Back to the pictures',
        moreTiles: 'More pictures',
    },
};
//# sourceMappingURL=food.en.js.map